import { useEffect, useState, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { FaPlus, FaMinus } from "react-icons/fa";
import FancyButtons from "../FancyButtons";

import style from "./style.module.scss";

var showBranco = false;

function BrancoAnim({ page, text, number }) {
  const [brancoTab, setBrancoTab] = useState("");
  const [brancoKeys, setBrancoKeys] = useState([]);
  const [specialTabs, setSpecialTabs] = useState([]);

  const part = useRef();
  const history = useHistory();
  const location = useLocation();

  const brancoId = Math.floor(Math.random() * 10000);

  let ourText = text[page];
  if (ourText) ourText = text[page]["brancoanim" + (number ?? "")];

  useEffect(() => {
    showBranco = false;
  }, []);

  useEffect(() => {
    if (!text[page]) return null;
    var ks = (() => {
      if (!text) return;
      var keys = ourText;
      if (!keys) return;

      keys = Object.keys(keys);

      // if (keys.length == 1) return;

      // console.log("THE KEYS", keys);
      if (keys.includes("specialTabs")) {
        keys.splice(keys.indexOf("specialTabs"), 1);
        setSpecialTabs(ourText.specialTabs);
      }

      return keys;
    })();

    if (ks) {
      setBrancoKeys(ks);
      setBrancoTab(ks[0]);
    }
  }, [text]);

  if (!text[page]) return null;

  function collapsible(id, col) {
    // console.log("targeting", id + "data");
    document
      .querySelector("." + id + "data")
      .classList.add(col ? "collapse-dacontent" : "show-dacontent");
    document
      .querySelector("." + id + "data")
      .classList.remove(col ? "show-dacontent" : "collapse-dacontent");

    document.querySelector("#" + id + "plus").style.display = col
      ? "block"
      : "none";
    document.querySelector("#" + id + "minus").style.display = col
      ? "none"
      : "block";

    // document.querySelector(`.${id}button`).innerHTML = `lees ${col?"more":"less"}`;
    // console.log("Ordered to collapse", col);
    if (col) {
      setTimeout(
        () => part.current.scrollIntoView({ behavior: "smooth" }),
        200
      );
    }
    return !col;
  }

  var brancoDataText = text != undefined && ourText && ourText[brancoTab];

  const specialTabButtons = {
    // "Het Team": {
    //     text: "Het Team", onClick: (e) => {
    //         if (e.ctrlKey)
    //             window.open(window.location.href + "team/", "_blank");
    //         else
    //             history.push("/team");
    //     },
    //     "index": 1
    // }
  };

  return (
    <div
      className={style.BrancoAnim}
      style={{ position: "relative" }}
      ref={part}
    >
      <div className={style.subBrancoAnim}>
        <div className="transition-pictures-container">
          <video
            src="/Videos/Siesta Homes.mp4"
            className={style.video}
            preload="false"
            autoPlay={true}
            muted={true}
            playsInline={true}
            loop={true}
          ></video>
        </div>
        <div className={"col no-padding-mg m-auto " + style.textCnt}>
          <div className={style.textArea}>
            <div className={style.title + " .title-font"}>
              {text && text[page]?.brancoanim?.title}
            </div>
            <div className={style.subTitle + " .title-font"}>
              {text && text[page]?.brancoanim?.subtitle}
            </div>
            <div className={style.breaker}></div>
            <div
              className={style.text}
              dangerouslySetInnerHTML={{
                __html: text && text[page]?.brancoanim?.text,
              }}
            ></div>
            <div className={style.button}>EVEN BABBELEN</div>
            <div className={style.menus}>
              <div className={style.menu}>Hoe aankopen</div>
              <div className={style.divider}>|</div>
              <div className={style.menu}>Bezoeken </div>
              <div className={style.divider}>|</div>
              <div className={style.menu}>Kosten </div>
              <div className={style.divider}>|</div>
              <div className={style.menu}>Advocaat </div>
            </div>
          </div>
        </div>
        <FancyButtons />
      </div>
    </div>
  );
}

function TabItem({ onClick, text }) {
  return (
    <span {...{ onClick }} className="branco-tabs-link">
      {text}
    </span>
  );
}

export default BrancoAnim;
